export const dedupeTabsById = <TTab extends { id: string }>({
  tabs,
}: {
  tabs: TTab[];
}): TTab[] => {
  const seenIds = new Set<string>();
  return tabs.filter((tab) => {
    if (seenIds.has(tab.id)) {
      return false;
    }
    seenIds.add(tab.id);
    return true;
  });
};
